import { useState } from 'react';
import { Box, Divider, TextField, Typography, Button, FormControl, Chip, FormControlLabel, Checkbox, IconButton, useMediaQuery, Tooltip } from '@material-ui/core';
import { CameraPlusIcon, CloseIcon } from 'asterX-UI/Icons';
import { LoaderBackdrop } from 'asterX-UI/Loaders';
import { PageContainer } from 'components/PageContainer';
import { makeStyles } from '@material-ui/core/styles';
import { memo } from 'react';
import { getAllCategory } from 'requests/category';
import { createPost, getPostById, updatePost } from 'requests/postsApi';
import { useEffect } from 'react';
import { NEWS_API_URL } from 'lib/api';
import axios from 'axios';
import Lightbox from 'react-image-lightbox';
import { useSnackbar } from 'notistack';
import { HOME_PATH } from 'routes/constants.routes';
import { useRoutes } from 'hooks';
import { useLocation } from 'react-router';
import MoodIcon from '@material-ui/icons/Mood';
import Picker from 'emoji-picker-react';

const useStyles = makeStyles((theme) => ({
  container: {
    marginBottom: theme.spacing(5),
    paddingRight: theme.spacing(4),
    paddingLeft: theme.spacing(4),
  },
  marginBottom: {
    marginBottom: theme.spacing(3),
  },
  mobile: {
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  desktop: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
}));

const AdminPage = () => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const { goTo } = useRoutes();
  const location = useLocation();

  const [allCategory, setAllCategory] = useState([]);

  const [news, setNews] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(null);
  const [loading, setLoading] = useState(false);
  const [bar, setBar] = useState(false);
  const [videoLink, setVideoLink] = useState('');

  const id = location.pathname.split('/')[2];

  const getNews = async (id) => {
    if (!id) {
      news.thumbnail = [];
      news.categoryCode = '';
      news.categoryId = '';
      news.title = '';
      news.text = '';
      news.commentsAllowed = false;

      return;
    }
    const res = await getPostById(id);

    setNews(res);
  };

  useEffect(() => {
    getNews(id);
  }, []);

  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'));

  useEffect(() => {
    try {
      getAllCategory().then((res) => {
        if (res && !res.message) {
          setAllCategory(res);
        }
      });
    } catch (error) {
      console.error(error);
      setAllCategory([]);
    }
  }, []);

  const extractVideoId = (url) => {
    const videoIdMatch = url.match(/youtube\.com\/watch\?v=([a-zA-Z0-9_-]{11})/);
    if (videoIdMatch) {
      return videoIdMatch[1];
    }

    const embedUrlMatch = url.match(/youtube\.com\/embed\/([a-zA-Z0-9_-]{11})/);
    if (embedUrlMatch) {
      return embedUrlMatch[1];
    }

    const shortUrlMatch = url.match(/youtu\.be\/([a-zA-Z0-9_-]{11})/);
    if (shortUrlMatch) {
      return shortUrlMatch[1];
    }

    return null;
  };

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    if (name === 'videoLink') {
      setVideoLink(value);
    } else {
      setNews((prevState) => ({ ...prevState, [name]: value }));
    }
  };

  const handleChangeCheckBox = (event) => {
    const name = event.target.name;
    setNews((prevState) => ({ ...prevState, [name]: !news.commentsAllowed }));
  };

  const onEmojiClick = (event, emojiObject) => {
    setBar(false);
    setNews((prevState) => ({ ...prevState, text: prevState.text + emojiObject.emoji }));
  };

  const handleClick = (res) => {
    news.categoryId = res.id;
    setNews((prevState) => ({ ...prevState, categoryCode: res.code }));
    console.log();
  };

  const removePhoto = (index) => {
    const newFileArr = [...news?.thumbnail];
    newFileArr.splice(index, 1);
    setNews((prevState) => ({ ...prevState, thumbnail: newFileArr }));
  };

  const uploadPhoto = (photo) => {
    setLoading(true);
    try {
      let formData = new FormData();
      formData.append('file', photo);
      axios
        .post(NEWS_API_URL + '/files/uploadFile', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          },
        })
        .then((res) => {
          setNews((prevState) => ({ ...prevState, thumbnail: [...news?.thumbnail, res?.data?.fileDownloadUri] }));
          setLoading(false);
        });
    } catch (error) {
      setLoading(false);
      if (error.response.status === 400) {
        return;
      }
    }
    setLoading(false);
  };

  const handleCapture = (target) => {
    if (target.files) {
      if (target.files.length !== 0) {
        const file = target.files[0];

        uploadPhoto(file);
      }
    }
  };

  const goToHomePage = () => {
    goTo(HOME_PATH);
  };

  const handleAddLink = () => {
    if (videoLink) {
      setNews((prevState) => ({ ...prevState, thumbnail: [...news?.thumbnail, `https://www.youtube.com/embed/${extractVideoId(videoLink)}`] }));
    }
  };

  const handleSubmit = () => {
    setLoading(true);
    const { title, text, categoryCode } = news || {};
    const fieldsToValidate = [
      { name: 'заголовка', value: title },
      { name: 'текста', value: text },
      { name: 'раздела', value: categoryCode },
    ];
    const invalidFields = fieldsToValidate.filter(({ value }) => value?.length < 1);
    if (invalidFields.length > 0) {
      invalidFields.forEach(({ name }) => {
        enqueueSnackbar(`Заполните поле ${name}!`, { variant: 'error' });
      });
      setLoading(false);
      return;
    }

    if (!id) {
      createPost(news).then((res) => {
        if (res.status === 200) {
          setLoading(false);
          enqueueSnackbar('Новость успешно создана', {
            variant: 'success',
          });
          setNews({});
        } else {
          enqueueSnackbar('Ошибка, повторите попытку еще раз!', {
            variant: 'error',
          });
          setLoading(false);
        }
      });
    } else {
      updatePost(news).then((res) => {
        if (!!res) {
          enqueueSnackbar('Новость успешно отредактировано!', {
            variant: 'success',
          });
          setLoading(false);
          setNews({});
          goTo(HOME_PATH);
        } else {
          enqueueSnackbar('Ошибка, повторите попытку еще раз!', {
            variant: 'error',
          });
          setLoading(false);
        }
      });
    }

    setLoading(false);
    return;
  };

  return (
    <PageContainer maxWidth={'lg'}>
      <LoaderBackdrop loading={loading} />
      <Box className={classes.container}>
        <Button color='primary' onClick={goToHomePage}>
          Назад
        </Button>
        <Typography variant='h4'>{id ? 'Редактировать Новость' : 'Новая Новость'}</Typography>
      </Box>

      <Box className={classes.container}>
        <Divider variant='fullWidth' className={classes.marginBottom} />
        <Box className={classes.marginBottom}>
          <Typography variant='h6'>Заголовок*</Typography>
          <TextField fullWidth name='title' value={news?.title || ''} onChange={handleChange}></TextField>
        </Box>
        <Box className={classes.marginBottom}>
          <Typography variant='h6'>Текст*</Typography>
          <Box style={{ position: 'relative' }}>
            <TextField fullWidth multiline minRows='10' name='text' value={news?.text || ''} onChange={handleChange}></TextField>
            <Box
              style={{
                position: 'absolute',
                right: 0,
                bottom: 0,
              }}
            >
              <Tooltip title={'Добавить эмодзи'}>
                <IconButton color={'primary'} onClick={() => setBar(!bar)}>
                  <MoodIcon />
                </IconButton>
              </Tooltip>
            </Box>
            {!!bar && (
              <>
                <Picker
                  onEmojiClick={onEmojiClick}
                  disableSearchBar
                  disableSkinTonePicker
                  pickerStyle={{
                    position: 'absolute',
                    zIndex: 200,
                    right: 0,
                    width: '70%',
                    bottom: '70%',
                  }}
                />
                <Box style={{ position: 'fixed', zIndex: 199, width: '100vw', height: '100vh', top: 0, left: 0 }} onClick={() => setBar(!bar)} />
              </>
            )}
          </Box>
        </Box>
        <Box className={`${classes.mobile} ${classes.marginBottom}`}>
          <Box display='flex' justifyContent='flex-end'>
            <Button variant={'contained'} size={'large'} fullWidth color='primary'>
              <label htmlFor='icon-button-up'>Прекрепить файл</label>
              <input
                multiple
                accept='image/*, .xls,.xlsx/*, application/pdf'
                capture='environment'
                id='icon-button-up'
                type='file'
                onChange={(e) => {
                  handleCapture(e.target);
                }}
                style={{ display: 'none' }}
              />
            </Button>
          </Box>
        </Box>
        <Box className={`${classes.desktop} ${classes.marginBottom}`} display='flex' justifyContent='space-between'>
          <Typography variant='h6' display='inline'>
            Прекрепить файл
          </Typography>

          <label htmlFor='icon-button-up'>
            <div className={classes.button}>
              <CameraPlusIcon style={{ width: '40px', height: '40px', cursor: 'pointer' }} />
            </div>
          </label>
          <input
            multiple
            accept='image/*, .xls,.xlsx/*, application/pdf'
            capture='environment'
            id='icon-button-up'
            type='file'
            onChange={(e) => {
              handleCapture(e.target);
            }}
            style={{ display: 'none' }}
          />
        </Box>

        <Box item xs={12} md={12} style={{ flexWrap: 'wrap' }}>
          <div style={{ display: 'flex', flexWrap: 'wrap' }}>
            {news?.thumbnail?.map((photo, index) => (
              <div key={index} style={{ display: 'flex', marginTop: 4, marginRight: '10px' }}>
                {photo?.includes('youtube') ? (
                  <iframe
                    style={{
                      marginRight: 6,
                      width: 140,
                      height: 70,
                      borderRadius: 12,
                    }}
                    src={photo}
                    title='YouTube video player'
                    frameborder='0'
                    allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
                    allowfullscreen
                  ></iframe>
                ) : (
                  <img
                    src={photo}
                    onClick={() => {
                      setIsOpen(true);
                      setPhotoIndex(index);
                    }}
                    style={{
                      marginRight: 6,
                      width: 140,
                      height: 70,
                      borderRadius: 12,
                    }}
                  />
                )}
                <IconButton
                  variant={'outlined'}
                  size={'small'}
                  style={{ width: '5px', height: '20px', display: 'inline' }}
                  color='secondary'
                  onClick={() => {
                    removePhoto(index);
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </div>
            ))}
          </div>
        </Box>
        <Box className={classes.marginBottom}>
          <Box display='flex' flexDirection={isMobile ? 'column' : 'row'} alignItems='end'>
            <Box width={isMobile ? '100%' : '75%'} marginBottom={isMobile && '10px'}>
              <FormControl fullWidth>
                <Typography variant='h6'>Ссылка на видео</Typography>
                <TextField name='videoLink' value={videoLink} onChange={handleChange} />
              </FormControl>
            </Box>
            <Box width={isMobile ? '100%' : '25%'} marginLeft={!isMobile && 1}>
              <Button variant='contained' color='primary' onClick={handleAddLink} style={{ width: '100%' }}>
                Загрузить видео
              </Button>
            </Box>
          </Box>
        </Box>
        <Box className={classes.marginBottom}>
          <Typography variant='h6'>Раздел*</Typography>
          <Box display='flex' flexWrap='wrap' justifyContent='flex-start'>
            {(allCategory || []).map((res) => (
              <Box key={res.id} marginRight={2} marginBottom={2}>
                <Chip label={res.name} color={news?.categoryId === res.id ? 'secondary' : 'primary'} onClick={() => handleClick(res)}></Chip>
              </Box>
            ))}
          </Box>
        </Box>
        <Box className={classes.marginBottom}>
          <FormControlLabel
            control={<Checkbox color='primary' checked={Boolean(news?.commentsAllowed)} onChange={handleChangeCheckBox} name='commentsAllowed' />}
            label='Разрешить комментировать'
          />
        </Box>
        <Box>
          <Button variant={'contained'} size={'large'} color='primary' onClick={handleSubmit} style={{ width: isMobile && '100%' }}>
            Опубликовать
          </Button>
        </Box>
      </Box>
      {!!isOpen && (
        <Lightbox
          mainSrc={news?.thumbnail[photoIndex]}
          imageCaption={photoIndex + 1 + '/' + news?.thumbnail.length}
          nextSrc={news?.thumbnail[(photoIndex + 1) % news?.thumbnail.length]}
          prevSrc={news?.thumbnail[(photoIndex + news?.thumbnail.length - 1) % news?.thumbnail.length]}
          onCloseRequest={() => {
            setIsOpen(false);
            setPhotoIndex(0);
          }}
          onMovePrevRequest={() => setPhotoIndex((photoIndex + news?.thumbnail.length - 1) % news?.thumbnail.length)}
          onMoveNextRequest={() => setPhotoIndex((photoIndex + 1) % news?.thumbnail.length)}
        />
      )}
    </PageContainer>
  );
};

export default memo(AdminPage);
